import { createAction, handleActions } from 'redux-actions';

const setFilter = createAction("SCREENS/SUPPLIERS/SET_FILTER");

const defaultState = {
  active: 'all'
};

const reducer = handleActions(
  {
    [setFilter]: (state, action) => ({ ...state, [action.payload.key]: action.payload.value })
  },
  defaultState
);

export { setFilter, reducer };
